import { FormControlLabel, Switch, SwitchProps } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import { ReactNode, useEffect, useState } from 'react';

import { useFilter } from '../context';

export interface ToggleFilterProps extends Omit<SwitchProps, 'onChange' | 'checked'> {
    filterName: string;
    inverted?: boolean;
    checked?: boolean;
    onChange?: (value: boolean) => void;
}

export const ToggleFilter = (props: ToggleFilterProps) => {
    const { filter, updateFilter, registerFilterMap } = useFilter();
    const { filterName, inverted = false, checked, onChange, ...switchProps } = props;
    const [isChecked, setIsChecked] = useState(
        checked !== undefined ? checked : filter.get(filterName) === 'true' ? !inverted : inverted
    );

    useEffect(() => {
        if (checked === undefined) {
            return;
        }
        // This will also trigger the searchparams update
        setIsChecked(checked);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [checked]);

    useEffect(() => {
        filter.delete(filterName);
        if (isChecked !== inverted) {
            filter.set(filterName, 'true');
        }
        updateFilter(filter);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isChecked]);

    const handleClick = () => {
        setIsChecked(!isChecked);
        onChange?.(!isChecked);
    };

    const getDisplayValue = (value: unknown): ReactNode => {
        if (typeof value !== 'string') {
            return '';
        }

        return <FormattedMessage id={`app.filter.toggle.${filterName}`} />;
    };

    registerFilterMap(filterName, getDisplayValue);

    return (
        <FormControlLabel
            control={<Switch {...switchProps} color="primary" checked={isChecked} onClick={handleClick} />}
            label={<FormattedMessage id={`app.filter.toggle.${filterName}`} />}
        />
    );
};
